module.exports = __webpack_public_path__ + "c636bef20710b3c10f0654671d42f99a.pdf";